module.exports = __webpack_public_path__ + "img/mayBanner_600.1df01e57.png";